import React, { useMemo, useState } from "react";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { useTable } from "react-table";
import { DraggableTableRow } from "./DraggableTableRow";
import  StaticTableRow  from "./StaticTableRow";
import TableEmptyState from "../../common/TableEmptyState";
import {
    Paper,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell ,
    TableContainer,
  } from "@material-ui/core";
  
const TableCom = ({ 
    columns, 
    data, 
    setData,
    info,
    windowScreen,
    inputValues,
    tickData,
    handleOrderExit,
    handleOrderexecute,
    handleOrderRefresh,
    handleOrderCopy,
    updateFieldValue,
    handlessltpPrice,
    changeBuySell,
    strikeChange,
    cellTypeClick,
    expiryOptions,
    handleExpiryChange,
    handleProductChange,
    orderTypeClick,
    handleFieldcClick,
    handleSltpBasisChange,
    handleShowCharges
}) => {
  const [activeId, setActiveId] = useState();
  const items = useMemo(() => data?.map(({ id }) => id), [data]);
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  });
  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(KeyboardSensor, {})
  );

  function handleDragStart(event) {
    setActiveId(event.active.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    console.log("active", active, over)
    if (active?.id !== over?.id) {
      setData((data) => {
        const oldIndex = items.indexOf(active?.id);
        const newIndex = items.indexOf(over?.id);
        return arrayMove(data, oldIndex, newIndex);
      });
    }

    setActiveId(null);
  }

  function handleDragCancel() {
    setActiveId(null);
  }

  const selectedRow = useMemo(() => {
    if (!activeId) {
      return null;
    }
    const row = rows.find(({ original }) => original.id === activeId);
    prepareRow(row);
    return row;
  }, [activeId, rows, prepareRow]);
 
  // Render the UI for your table
  return (
    <DndContext
      sensors={sensors}
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
      onDragCancel={handleDragCancel}
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis]}
    >
      <Table stickyHeader className="basket-table-fixed" {...getTableProps()}>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TableCell align={column.align} className={column.render("id") === "drag" ? "blank-th" :""} id={column.render("id") === "drag" ? "" : "fno-table-header-cell"} {...column.getHeaderProps()}>{column.render("Header")}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.length === 0 ? (
            <TableEmptyState colSpan={headerGroups?.[0]?.headers?.length || 10} />
          ) : (
            <SortableContext items={items} strategy={verticalListSortingStrategy}>
              {rows.map((row, i) => {
                prepareRow(row);
                return <DraggableTableRow 
                  key={row.original.id} 
                  row={row} 
                  info={info}
                  windowScreen={windowScreen}
                  inputValues={inputValues}
                  lp={tickData[row.original.instrumentToken]?.lp || 0}

                  index={i}
                  handleOrderExit={handleOrderExit}
                  handleOrderexecute={handleOrderexecute}
                  handleOrderRefresh={handleOrderRefresh}
                  handleOrderCopy={handleOrderCopy}
                  updateFieldValue={updateFieldValue}
                  handlessltpPrice={handlessltpPrice}
                  changeBuySell={changeBuySell}
                  strikeChange={strikeChange}
                  cellTypeClick={cellTypeClick}
                  expiryOptions={expiryOptions}
                  handleExpiryChange={handleExpiryChange}
                  handleProductChange={handleProductChange}
                  orderTypeClick={orderTypeClick}
                  handleFieldcClick={handleFieldcClick}
                  handleSltpBasisChange={handleSltpBasisChange}
                  handleShowCharges={handleShowCharges}
              />;
              })}
            </SortableContext>
          )}
        </TableBody>
      </Table>
      <DragOverlay>
        {activeId && (
          <Table style={{ width: "100%" }}>
            <TableBody>
              <StaticTableRow row={selectedRow} />
            </TableBody>
          </Table>
        )}
      </DragOverlay>
    </DndContext>
  );
}

export default TableCom